export const TreeTypes = {
    Circular: 'cr',
    Diagonal: 'dg',
    Hierarchical: 'hr',
    Radial: 'rd',
    Rectangular: 'rc',
};
export const Shapes = {
    Chevron: 'chevron',
    ChevronInverted: 'chevron-inverted',
    ChevronLeft: 'chevron-left',
    ChevronRight: 'chevron-right',
    Circle: 'circle',
    Cross: 'cross',
    Diamond: 'diamond',
    Dot: 'dot',
    DoubleChevron: 'double-chevron',
    DoubleChevronInverted: 'double-chevron-inverted',
    DoubleChevronLeft: 'double-chevron-left',
    DoubleChevronRight: 'double-chevron-right',
    Heptagon: 'heptagon',
    HeptagonInverted: 'heptagon-inverted',
    Heptagram: 'heptagram',
    HeptagramInverted: 'heptagram-inverted',
    Hexagon: 'hexagon',
    Hexagram: 'hexagram',
    Octagon: 'octagon',
    Octagram: 'octagram',
    Pentagon: 'pentagon',
    PentagonInverted: 'pentagon-inverted',
    Pentagram: 'pentagram',
    PentagramInverted: 'pentagram-inverted',
    Plus: 'plus',
    Square: 'square',
    Star: 'pentagram',
    StarInverted: 'pentagram-inverted',
    Tetragram: 'tetragram',
    Triangle: 'triangle',
    TriangleInverted: 'triangle-inverted',
    TriangleLeft: 'triangle-left',
    TriangleRight: 'triangle-right',
    Wye: 'wye',
    WyeInverted: 'wye-inverted',
};
/** Default name for root node to use for newick strings with no name root */
export const NO_NAME_ROOT = '[root]';
/** Based on phylocanvas.gl */
export function parseNewick(s) {
    const ancestors = [];
    let tree = { name: '' };
    const tokens = s.split(/\s*(;|\(|\)|,|:)\s*/);
    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];
        switch (token) {
            case '(':
                { // new children
                    const subtree = { name: '' };
                    tree.children = [subtree];
                    ancestors.push(tree);
                    tree = subtree;
                }
                break;
            case ',':
                { // another branch
                    const subtree = { name: '' };
                    ancestors[ancestors.length - 1].children.push(subtree);
                    tree = subtree;
                }
                break;
            case ')': // optional name next
                tree = ancestors.pop();
                break;
            case ':': // optional length next
                break;
            default:
                const x = tokens[i - 1];
                if (x == ')' || x == '(' || x == ',')
                    tree.name = token;
                else if (x == ':')
                    tree.branch_length = parseFloat(token);
        }
    }
    if (!tree.name)
        tree.name = NO_NAME_ROOT; // Fix for consistency with TreeHelper at Dendrogram
    return tree;
}
//# sourceMappingURL=phylocanvas.js.map